<template>
    <b-modal :active.sync="isActive"
             has-modal-card full-screen >
        <div class="modal-card">
            <b-loading  :active.sync="isFullScreenSearching" ></b-loading>
            <header class="modal-card-head">
                <p class="modal-card-title"> {{ParasiteSelect}}
                    <span class="tag is-warning">  {{idlab}}</span>

                </p>


                <button class="delete" aria-label="close"   @click="closeBtn" ></button>
            </header>

            <section class="modal-card-body">

                <!--***********   Header      ********************-->
                <nav class="level is-mobile">
                    <div class="level-left">

                    </div>
                    <div class="level-right">
                        <div class="level-item">
                            <b-button icon-left="plus" type="is-success" @click="addTemplate"
                            >  Add </b-button>
                        </div>
                    </div>
                </nav>

                <div  v-for="(dataBact,index) in arrTmpDataBACTSpecLN" :key="dataBact.idbact_uuid"  class="box" style="margin-top: 50px">
                    <Each_Parasite
                            :enable="true"
                            :data_bact="dataBact"
                            :index ="index+1"
                            @delete_idbact_uuid="delete_idbact_uuid"
                    />

                </div>





            </section>
            <footer class="modal-card-foot">
                <!--                <button class="button is-danger"   @click="closeBtn" >Cancel</button>-->
                <b-button type="is-danger"
                          icon-right="close"
                          @click="closeBtn" >Cancel</b-button>
                <b-button type="is-success"
                          icon-right="cloud-upload"
                          @click="saveBtn" >Save </b-button>
            </footer>

        <SelectDrug
                v-if="isShowSelectDrug"
                :isShowing = isShowSelectDrug
                @closeSelectDrug = "closeSelectDrug"
                @closeSelectDrugWithData = "closeSelectDrugWithData"
        />
        </div>
    </b-modal>
</template>

<script>
    import globalconst from "../../../mixins/globalconst";
    import {mapState} from "vuex";
    import Each_Parasite from "../Parasite/Each_Parasite";
    import SelectDrug from "../Bact/SelectDrug";
    import axios from "axios";
    import {    genUUID  , getBaseURLforBackEnd , getConfigAxios }  from '@/utils.js'
   
    export default {
        name: "PlusParasite",

        props:{
            idlab : String,
            isShowing : Boolean,
        },

        components:{
            Each_Parasite,
            SelectDrug
        },

        mixins:[globalconst],
        computed: {
            ...mapState({
                tmplatePARA: state => state.parasite.tmplatePARA,
                clientIP : state => state.master_data.clientIP,
                access_token: state => state.master_data.access_token,
            }),
        },
        methods:{
            closeSelectDrugWithData(payload){
                payload.forEach(dat=>{
                    this.arrTmpDataBACTSpecLN.drugs.push(
                        {
                            "iddrug": dat.id,
                            "drug_name": dat.name,
                            "idresult": null,
                            "result_name": null,
                            "idmic_prefix": null,
                            "mic_prefix": null,
                            "mic_val": null,
                            "remark": "",
                            "sort_id": "",
                            "iddrug_uuid":   genUUID(12)
                        }
                    )
                })

                this.isShowSelectDrug = false
            },
            closeSelectDrug(){
                this.isShowSelectDrug = false
            },
            delete_idbact_uuid(_idbact_uuid){
               // console.log(_idbact_uuid)

                const  tmp =  this.arrTmpDataBACTSpecLN.find(dat=>{
                    return dat.idbact_uuid == _idbact_uuid
                })


                const memberIndex =  this.arrTmpDataBACTSpecLN.indexOf(tmp)
                this.arrTmpDataBACTSpecLN.splice(memberIndex,1)



            },
            addTemplate(){
                var tmp = JSON.parse(JSON.stringify(this.tmplatePARA))
                tmp.idbact_uuid = genUUID(12)
                for(var i=0;i<tmp.drugs.length;i++){
                    tmp.drugs[i].iddrug_uuid  = genUUID(9)
                }

                this.arrTmpDataBACTSpecLN.push( tmp )
                // console.log(tmp)
            },
            closeBtn(){
                this.$emit('closePlusParasite')
            },
            checkDataValid(){


                // check  Bacterial at least one
                if(this.arrTmpDataBACTSpecLN.length === 0 ){
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: `Bacterial Culture No information <b>  is empty  </b>`,
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                    return false
                }

                //  check Bacterial exist in every obj
                for(var i =0;i<this.arrTmpDataBACTSpecLN.length;i++){
                    if( this.arrTmpDataBACTSpecLN[i].idbact === null){
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `Bacterial Culture No. <b> ${i+1} </b> is empty <i>Bacterial name</i> `,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        return false
                    }
                }


                //  check length iddrug in every obj
                for(var j =0;j<this.arrTmpDataBACTSpecLN.length;j++){
                    if( this.arrTmpDataBACTSpecLN[j].drugs.length === 0 && this.arrTmpDataBACTSpecLN[j].want_data_drugs ){
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `Bacterial Culture No. <b> ${j+1} </b>  No information for drug <b>(at least one data!)</b>  `,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        return false
                    }
                }

                //  check result in iddrug in every obj
                for(var k =0;k<this.arrTmpDataBACTSpecLN.length;k++){
                   if( this.arrTmpDataBACTSpecLN[k].want_data_drugs) {
                       for (var k1 = 0; k1 < this.arrTmpDataBACTSpecLN[k].drugs.length; k1++) {
                           if (this.arrTmpDataBACTSpecLN[k].drugs[k1].idresult === null) {
                               this.$buefy.dialog.alert({
                                   title: 'Error',
                                   message: `Bacterial Culture No. <b>${k + 1}</b>  for drug No. <b>${k1 + 1}</b>   is  <b>  empty </b>  `,
                                   type: 'is-danger',
                                   hasIcon: true,
                                   icon: 'times-circle',
                                   iconPack: 'fa',
                                   ariaRole: 'alertdialog',
                                   ariaModal: true
                               })
                               return false
                           }
                       }
                   }
                }



                return true
            },
            saveBtn(){

                if(this.checkDataValid()){
                    for(var i=0;i<this.arrTmpDataBACTSpecLN.length;i++){
                        for(var i1=0; i1< this.arrTmpDataBACTSpecLN[i].drugs.length;i1++ ) {
                            this.arrTmpDataBACTSpecLN[i].drugs[i1].sort_id = `${i1}`
                        }
                    }


                    // console.log(JSON.stringify(this.arrTmpDataBACTSpecLN))
                    const  datTo = {
                        "idlab": this.idlab ,
                        "ip": this.clientIP,
                        "data": this.arrTmpDataBACTSpecLN

                    }


                    //  console.log(JSON.stringify(datTo))

                    const vm = this
                    axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}` 
                    axios.post(`${getBaseURLforBackEnd()}/api/newinsert_pararesult_plus`, datTo, getConfigAxios())
                        .then((res)=>{
                            vm.$buefy.toast.open({
                                message:  `${res.data.msg}`,
                                type: 'is-success'
                            })

                            vm.$emit('closePlusParasite_WithChange')

                        })
                        .catch((err)=>{
                            this.$buefy.dialog.alert({
                                title: 'Error',
                                message: `${err.message}`,
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'times-circle',
                                iconPack: 'fa',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                            })
                        })
                }

            }
        },

        data(){
            return {
                isActive : true,
                isFullScreenSearching : false,

                arrTmpDataBACTSpecLN: [],
                isShowSelectDrug : false

            }
        }
    }
</script>

<style scoped>

</style>